<div class="sponser-logo">
  <div class="container">
    <div class="sponser-logos">
      <div class="logo">
        <img src="../../../assets/image/play-tennis-logo.webp" alt="play-tennis-logo">
      </div>
    </div>
  </div>
</div>